import React from 'react';

import { type EmailMessagesFilterInput } from '@dashboard/generated/wp/platform';
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material';

import SearchInput from './SearchInput';

type Props = {
  title: JsxNode;
  filter: EmailMessagesFilterInput;
  setFilter: (value: EmailMessagesFilterInput) => void;
};

export default function TitleBar({ title, filter, setFilter }: Props) {
  return (
    <Stack
      justifyContent="space-between"
      sx={{
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: { xs: 'flex-start', md: 'center' },
        gap: { xs: 2, md: 0 },
      }}
    >
      {title}
      <Stack
        direction="row"
        alignItems="center"
        spacing={{ xs: 1, md: 2 }}
        justifyContent="space-between"
        sx={{ width: { xs: '100%', md: 'auto' } }}
      >
        <ToggleButtonGroup
          size="small"
          value={filter.timePeriod}
          exclusive
          onChange={(_, val) => setFilter({ timePeriod: val })}
        >
          <ToggleButton value="ALL">All</ToggleButton>
          <ToggleButton value="WEEK">Week</ToggleButton>
          <ToggleButton value="MONTH">Month</ToggleButton>
        </ToggleButtonGroup>

        <ToggleButtonGroup
          size="small"
          value={filter.environment}
          exclusive
          onChange={(_, val) => setFilter({ environment: val })}
        >
          <ToggleButton value="ALL">All</ToggleButton>
          <ToggleButton value="LIVE">Live</ToggleButton>
          <ToggleButton value="SANDBOX">Test</ToggleButton>
        </ToggleButtonGroup>

        <SearchInput filter={filter} setFilter={setFilter} />
      </Stack>
    </Stack>
  );
}
